<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V9C11 9.55228 11.4477 10 12
      10C12.5523 10 13 9.55228 13 9V8Z"
      fill="currentColor"
    />
    <path
      d="M10 13C10 12.4477 10.4477 12 11 12H13C13.5523 12 14 12.4477 14 13C14 13.5523 13.5523 14 13
      14H11C10.4477 14 10 13.5523 10 13Z"
      fill="currentColor"
    />
    <path
      d="M8 13C8 13.5523 7.55228 14 7 14C6.44772 14 6 13.5523 6 13C6 12.4477 6.44772 12 7 12C7.55228
      12 8 12.4477 8 13Z"
      fill="currentColor"
    />
    <path
      d="M7 18C7.55228 18 8 17.5523 8 17C8 16.4477 7.55228 16 7 16C6.44772 16 6 16.4477 6 17C6
      17.5523 6.44772 18 7 18Z"
      fill="currentColor"
    />
    <path
      d="M18 13C18 13.5523 17.5523 14 17 14C16.4477 14 16 13.5523 16 13C16 12.4477 16.4477 12 17
      12C17.5523 12 18 12.4477 18 13Z"
      fill="currentColor"
    />
    <path
      d="M17 18C17.5523 18 18 17.5523 18 17C18 16.4477 17.5523 16 17 16C16.4477 16 16 16.4477 16
      17C16 17.5523 16.4477 18 17 18Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.47 2.152C11.7943 1.94933 12.2057 1.94933 12.53 2.152L16.53 4.652C16.8224 4.83474 17
      5.15521 17 5.5V8H21C21.5523 8 22 8.44772 22 9V20C22.5523 20 23 20.4477 23 21C23 21.5523
      22.5523 22 22 22L2 22C1.44772 22 1 21.5523 1 21C1 20.4477 1.44772 20 2 20V9C2 8.44772 2.44772
      8 3 8H7V5.5C7 5.15521 7.17762 4.83474 7.47 4.652L11.47 2.152ZM20 10V20H14V17C14 16.4477
      13.5523 16 13 16H11C10.4477 16 10 16.4477 10 17V20H4V10H8C8.55228 10 9 9.55228 9 9V6.05425L12
      4.17925L15 6.05425V9C15 9.55228 15.4477 10 16 10H20Z"
      fill="currentColor"
    />
  </svg>
</template>
